import React, {useContext, useEffect} from 'react';
import {Routes, Route, Navigate, useLocation} from 'react-router-dom';
import { authAdminRoutes, authRoutes, publicRoutes } from '../appRoutes';
import {MAIN_ROUTE} from '../utils/consts';
import { Context } from '../index';
import {check} from "../http/userAPI";

const AppRouter = (() => {
    const { user } = useContext(Context);
    const location = useLocation(); // ✅ Теперь `useLocation` работает
    const isAdmin = user.user.role === 'ADMIN';

    useEffect(() => {
        const updateUserData = async () => {
            const token = localStorage.getItem("token"); // ✅ Проверяем, есть ли токен
            if (!token) {
                return; // 🚫 Не запрашиваем `check()`, если токена нет
            }

            try {
                const data = await check();
                user.setUser(data);
            } catch (error) {
                console.error("Error refreshing user data", error);
            }
        };

        updateUserData();
    }, [location.pathname, user]); // 🔥 Вызываем `check` только при изменении пути


    return (
        <Routes>
            {user.isAuth && isAdmin && authAdminRoutes.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}

            {user.isAuth && authRoutes.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}

            {publicRoutes.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}
            <Route path="*" element={<Navigate to={MAIN_ROUTE} />} />

        </Routes>
    );
});


export default AppRouter;
